import React from 'react';
import { Shield } from 'lucide-react';
export function FooterSection() {
  return <footer className="py-12 sm:py-16 bg-black border-t border-white/5" data-id="element-29">
      <div className="max-w-4xl mx-auto px-5 sm:px-6 text-center" data-id="element-30">
        {/* Brand */}
        <div className="flex items-center justify-center gap-2 mb-6" data-id="element-31">
          <Shield size={18} className="text-crimson" data-id="element-32" />
          <span className="text-white font-black text-sm tracking-wider uppercase" data-id="element-33">
            Manual <span className="text-crimson" data-id="element-34">Prohibido</span>
          </span>
        </div>

        {/* Links */}
        <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 mb-8" data-id="element-35">
          <a href="#" className="text-gray-500 hover:text-gray-300 text-sm transition-colors" data-id="element-36">
            Términos y Condiciones
          </a>
          <span className="text-gray-700 hidden sm:inline" data-id="element-37">|</span>
          <a href="#" className="text-gray-500 hover:text-gray-300 text-sm transition-colors" data-id="element-38">
            Política de Privacidad
          </a>
          <span className="text-gray-700 hidden sm:inline" data-id="element-39">|</span>
          <a href="#" className="text-gray-500 hover:text-gray-300 text-sm transition-colors" data-id="element-40">
            Contacto
          </a>
        </div>

        {/* Disclaimer */}
        <p className="text-[11px] text-gray-600 leading-relaxed max-w-2xl mx-auto mb-6" data-id="element-41">
          AVISO LEGAL: Los resultados pueden variar de persona a persona. Este
          producto es un material educativo digital y no garantiza resultados
          específicos. Al realizar la compra, aceptás nuestros términos y
          condiciones. Este sitio no es parte de Facebook ni está respaldado por
          Facebook Inc. Después de abandonar Facebook, la responsabilidad no es
          de Facebook sino de nuestro sitio.
        </p>

        {/* Copyright */}
        <p className="text-gray-600 text-xs" data-id="element-42">
          &copy; {new Date().getFullYear()} Manual de Seducción Prohibida. Todos
          los derechos reservados.
        </p>
      </div>
    </footer>;
}